<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/quotation/index"> Manage Quotations  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update Quotations  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2 ">
  <div  class="card-body custom_bdr_rds">


                    <form @submit.prevent="UpdateQuotation()" >

<div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer</label>
            <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="squatation.idcustomer"  :options="mcustomers" ></v-select>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer Contact</label>
            <v-select class="font-size_def" label="label"  :options="contacts" v-model="squatation.customer_contact"  ></v-select>
    </div>
  </div>
  
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Quotation Date </label>
            <input type="date" v-model="squatation.received_date"   style="font-size: small;" class="form-control font-size_def bdr-rad" required>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales Person</label>
            <v-select class="font-size_def" label="label" v-model="sales" :options="salespeoples" ></v-select>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Brand </label>
           
            <v-select class="font-size_def" label="value" v-model="quotation.id_brand"  :options="mbrands"  @input="loadBrand"></v-select>
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Payment Method </label>
            <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Validity Period</label>
            <v-select class="font-size_def" label="label"  v-model="quotation.validity_period" :options="validity_period" ></v-select>
    </div>
  </div>


  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">US Dollar rate</label>
            <input  v-model="squatation.usd_rate"   style="font-size: small;" class="form-control bdr-rad" required>
    </div>
  </div>

  
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks</label>
           <textarea v-model="quotation.remarks" class="form-control bdr-rad" rows="2"></textarea>
    </div>
  </div>
</div>




<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
<h6 class="purchitem mb-2"><b>Existing Products</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr>
              
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Selling Price</label>
                  </div>
                </th>
               
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Discount %</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Line Amount</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> GP Margin</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> % GP Margin</label>
                  </div>
                </th>
                
              
             
            </tr>
          </thead>
          <tbody>

            <tr v-for="(quatation_detail, index) in quatation_details" :key="quatation_detail.id">
                <input v-model="quatation_detail.id" type="hidden"  style="font-size: small;" class="form-control">
                <input v-model="quatation_detail.ave_cost" type="hidden"  style="font-size: small;" class="form-control">
                <input v-model="quatation_detail.avlqty" type="hidden"  style="font-size: small;" class="form-control">
               
              <td style="width: 25%;" ><input v-model="quatation_detail.P_description" style="font-size: small;" class="form-control " disabled></td>
              <td><input v-model="quatation_detail.price" style="font-size: small;" class="form-control text_right" disabled></td>
              <td><input v-model="quatation_detail.qty" @input="updatqty(index)"  style="font-size: small;" class="form-control text_right" step="0"></td>
            <td>
                <input v-model="quatation_detail.line_discount" @input="updatdis(index)" style="font-size: small;" class="form-control text_right" >
            </td>
              
            <td>
                <input v-model="quatation_detail.line_amount" @input="updatlinamt(index)" style="font-size: small;" class="form-control text_right" >
            </td>
            <td>
                <input v-model="quatation_detail.gp_margin" @input="updatgp(index)" style="font-size: small;" class="form-control text_right" >
            </td>
            <td>
                <input v-model="quatation_detail.gp_margin_precentage" @input="updatgppre(index)" style="font-size: small;" class="form-control text_right" >
            </td>
              
              
            </tr>
            <tr >
             
             <td></td>
             <td>Sub Total</td>
             <td></td>
             
             <td></td>
             <td class="text_right" >{{ totalamt.line_total }}</td>
             <td class="text_right" >{{ totalamt.gp_total }}</td>
           
             <td class="text_right">{{ totalamt.gppre_total }}</td>
             
           </tr>
           <tr >
             
             <td></td>
             <td>Special Discount</td>
             <td></td>
             
           
             <td></td>
             <td><input v-model="quotation.special_discount"  style="font-size:small" class="form-control text_right" @input="spe_dis"></td>
             <td></td>
             <td></td>
        
             
           </tr>
           <tr >
            
             <td></td>
             <td>Total</td>
             <td></td>
             
             <td></td>
             <td class="text_right" >{{  totalamt.fintal_total }}</td>
            
            
             <td></td>
             <td></td>
             
           </tr>


          </tbody>
      </table>

      </div>

</div>
</div>



<br>





<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Add New Products</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr >
                <th></th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Selling Price</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Available Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Discount %</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Line Amount</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> GP Margin</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> % GP Margin</label>
                  </div>
                </th>
                
              
                <th></th>  
            </tr>
            
         
          </thead>
          <tbody>

        

            <tr>
                <td> </td>
              <td style="width: 20%;">
                <v-select   v-model="detail[0].idproduct" label="label"  :options="mproducts" @input="loadPrice(0)"></v-select>
              </td>
              <td><input v-model="detail[0].price"  style="font-size: small;" class="form-control" disabled>
                <input type="hidden" v-model="detail[0].ave_cost"  style="font-size: small;" class="form-control" >
              </td>
              <td><input  v-model="detail[0].avlqty" style="font-size: small;" class="form-control" disabled></td>
              <td><input  v-model="detail[0].qty" style="font-size: small;" class="form-control" @input="calculateqty(0)" ></td>
              <td>
                <input  v-model="detail[0].line_discount" style="font-size: small;" class="form-control" @input="calculatediscount(0)">
              </td>
              <td><input  v-model="detail[0].line_amount" style="font-size: small;" class="form-control" ></td>
              <td><input  v-model="detail[0].gp_margin" style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail[0].gp_margin_precentage" style="font-size: small;" class="form-control" ></td>
              <td class="custom-icon">  <b-icon @click="add" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
                <td>
                    <b-icon @click="remove" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                </td>
              <td> <v-select v-model="detail[key].idproduct" label="label"  :options="mproducts" @input="loadPrice(key)"></v-select></td>
              <td><input  v-model="detail[key].price" style="font-size: small;" class="form-control" disabled>
                <input type="hidden" v-model="detail[key].ave_cost"  style="font-size: small;" class="form-control" >
              </td>
              <td><input  v-model="detail[key].avlqty" style="font-size: small;" class="form-control" disabled></td>
              <td><input  v-model="detail[key].qty" style="font-size: small;" class="form-control" @input="calculateqty(key)" ></td>
              <td><input  v-model="detail[key].line_discount" style="font-size: small;" class="form-control" @input="calculatediscount(key)" ></td>
              <td><input  v-model="detail[key].line_amount" style="font-size: small;" class="form-control" ></td>
              <td><input  v-model="detail[key].gp_margin" style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail[key].gp_margin_precentage" style="font-size: small;" class="form-control" required></td>
              <td class="custom-icon"> 
              
                 <b-icon @click="add" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
           
            
            <tr >
                <td> </td>
              <td></td>
              <td>Total</td>
              <td></td>
              
              <td></td>
              <td></td>
              <td>{{ subtotal }}</td>
              <td>{{ gpmrg_total }}</td>
              <td>{{ gpMrgPre_total }}</td>
              <td></td>
              
            </tr>
           
           

     
          
            
          </tbody>


        </table>
       
    </div>
    </div>
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad ">Update</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
                <br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSalespeople();
    this.loadCustomer();
    this.loadAlldata();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'idquotation':this.$route.query.id,
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        mcustomers:[],
        mproducts:[],
        contacts:[],
      salespeoples:[

      ],
      squatation:{},
      totalamt:{},
        customer:{},
        
        quotation:{},
        sales:{},
        Brands:[],
        quatation_details:[],
        detail:[
      {},  
      ],
      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            // Add more options as needed
        ],
        validity_period: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
            // Add more options as needed
        ],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    

            async loadAlldata() {
       
     
       try {
         const { data} = await  axios.post('/squatation/loaddata',{idquotation:this.idquotation},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.squatation = data.squatation;
          this.quotation = data.quotation;
          this.sales = data.sales;
          this.quatation_details = data.quatation_details;
          this.totalamt = data.totalamt;
         
       } catch (error) {
         console.log(error.response);
       }
     },

          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/msalespeople/salespeopleload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.salespeoples = data.item_list;
        
      } catch (error) {
        console.log(error.response);
      }
    },

    
    async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/mcustomer/customerload',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mcustomers = data.customers;
          this.contacts = data.contacts;
          this.mbrands = data.mbrands;
          this.mproducts = data.mproducts;
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadcontact() {
       
     
       try {
         const { data} = await  axios.post('/mcustomer/loadcontact',{idcustomer:this.squatation.idcustomer},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.contacts = data.contacts;
          this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadBrand() {
       
     
       try {
         const { data} = await  axios.post('/mcustomer/loadproduct',{id_brand:this.quotation.id_brand},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mproducts = data.mproducts;
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadPrice(id) {
       
     
       try {
         const { data} = await  axios.post('/mproduct/loadprice',{idproduct:this.detail[id].idproduct},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.$set(this.detail[id], 'price', data.selling_price);
          this.$set(this.detail[id], 'avlqty', data.avl);
          this.$set(this.detail[id], 'ave_cost', data.ave_cost);
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async updatqty(id) {


      if(parseFloat(this.quatation_details[id].avlqty) < parseFloat(this.quatation_details[id].qty)){
      alert("You are not allowed enter more than remaining qty")
      this.$set(this.quatation_details[id], 'qty', this.quatation_details[id].avlqty);

      
     }

        const line_amount = this.quatation_details[id].qty*this.quatation_details[id].price *(100 - this.quatation_details[id].line_discount) / 100;
        this.$set(this.quatation_details[id], 'line_amount', line_amount);

    const gpMrg = (line_amount - this.quatation_details[id].ave_cost*this.quatation_details[id].qty).toFixed(2);
        this.$set(this.quatation_details[id], 'gp_margin', gpMrg);

        const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
        this.$set(this.quatation_details[id], 'gp_margin_precentage', gpMrgPre);


        let line_amount_tot = 0;
        let gpMrg_total1 = 0;
        let gpMrgPre_total = 0;
        for (let i = 0; i <= id; i++) {
        line_amount_tot = line_amount_tot + this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100;

        gpMrg_total1 = gpMrg_total1 + (( this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100) - this.quatation_details[i].ave_cost*this.quatation_details[i].qty);

        }

        this.totalamt.line_total = line_amount_tot.toFixed(2);
        this.totalamt.gp_total = gpMrg_total1.toFixed(2);

        this.totalamt.gppre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);


        this.totalamt.fintal_total = (line_amount_tot-this.quotation.special_discount).toFixed(2);

     },

     async updatdis(id) {

        const line_amount = this.quatation_details[id].price * this.quatation_details[id].qty * (100 - this.quatation_details[id].line_discount) / 100;
        this.$set(this.quatation_details[id], 'line_amount', line_amount);

        const gpMrg = (line_amount - this.quatation_details[id].ave_cost*this.quatation_details[id].qty).toFixed(2);
        this.$set(this.quatation_details[id], 'gp_margin', gpMrg);

        const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
        this.$set(this.quatation_details[id], 'gp_margin_precentage', gpMrgPre);

        let line_amount_tot = 0;
        let gpMrg_total = 0;
        let gpMrgPre_total = 0;
        for (let i = 0; i <= id; i++) {
        line_amount_tot = line_amount_tot + this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100;

        gpMrg_total = gpMrg_total + (( this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100) - this.quatation_details[i].ave_cost*this.quatation_details[i].qty);

 
 
        }
            this.totalamt.line_total = line_amount_tot.toFixed(2);
            this.totalamt.gp_total = gpMrg_total.toFixed(2);
            this.totalamt.gppre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);

            this.totalamt.fintal_total = (line_amount_tot-this.quotation.special_discount).toFixed(2);


     },



     async updatlinamt(id) {

      const discount = (100 - ((this.quatation_details[id].line_amount*100)/(this.quatation_details[id].price*this.quatation_details[id].qty))).toFixed(2);
      this.$set(this.quatation_details[id], 'line_discount', discount);


      const gpMrg = (this.quatation_details[id].line_amount - this.quatation_details[id].ave_cost*this.quatation_details[id].qty).toFixed(2);
      this.$set(this.quatation_details[id], 'gp_margin', gpMrg);

      const gpMrgPre = (gpMrg/this.quatation_details[id].line_amount*100).toFixed(2);
      this.$set(this.quatation_details[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100) - this.quatation_details[i].ave_cost*this.quatation_details[i].qty);

    
    
      }
            this.totalamt.line_total = line_amount_tot.toFixed(2);
            this.totalamt.gp_total = gpMrg_total.toFixed(2);
            this.totalamt.gppre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);

            this.totalamt.fintal_total = (line_amount_tot-this.quotation.special_discount).toFixed(2);
     },

     async updatgp(id) {

      const dis = (100-((parseFloat(this.quatation_details[id].gp_margin / this.quatation_details[id].qty) + parseFloat(this.quatation_details[id].ave_cost))*100/this.quatation_details[id].price)).toFixed(2);
        this.$set(this.quatation_details[id], 'line_discount', dis);

        const line_amount = (this.quatation_details[id].price * this.quatation_details[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.quatation_details[id], 'line_amount', line_amount);

        const gpMrgPre = (this.quatation_details[id].gp_margin/line_amount*100).toFixed(2);
        this.$set(this.quatation_details[id], 'gp_margin_precentage', gpMrgPre);

        let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100) - this.quatation_details[i].ave_cost*this.quatation_details[i].qty);

    
    
      }
            this.totalamt.line_total = line_amount_tot.toFixed(2);
            this.totalamt.gp_total = gpMrg_total.toFixed(2);
            this.totalamt.gppre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);

            this.totalamt.fintal_total = (line_amount_tot-this.quotation.special_discount).toFixed(2);



     },


     async updatgppre(id) {


      const dis =  (100 -(this.quatation_details[id].ave_cost*10000/((this.quatation_details[id].price)*(100-this.quatation_details[id].gp_margin_precentage)))).toFixed(2);
      this.$set(this.quatation_details[id], 'line_discount', dis);

      const line_amount = (this.quatation_details[id].price * this.quatation_details[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.quatation_details[id], 'line_amount', line_amount);

        const gpMrg = (this.quatation_details[id].line_amount - this.quatation_details[id].ave_cost*this.quatation_details[id].qty).toFixed(2);
      this.$set(this.quatation_details[id], 'gp_margin', gpMrg);

      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.quatation_details[i].price * this.quatation_details[i].qty * (100 - this.quatation_details[i].line_discount) / 100) - this.quatation_details[i].ave_cost*this.quatation_details[i].qty);

    
    
      }
      this.totalamt.line_total = line_amount_tot.toFixed(2);
            this.totalamt.gp_total = gpMrg_total.toFixed(2);
            this.totalamt.gppre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);

            this.totalamt.fintal_total = (line_amount_tot-this.quotation.special_discount).toFixed(2);





     },





     async calculateqty(id) {
      
     if(!this.detail[id].line_discount){
      this.detail[id].line_discount = 0;
     } 
  const line_amount = this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100;
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total1 = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total1 = gpMrg_total1 + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

  }

  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total1.toFixed(2);

  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  
     },

     async calculatediscount(id) {
     if(!this.detail[id].qty){
      this.detail[id].qty = 0;
     } 
  const line_amount = this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100;
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

 
 
  }
  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total.toFixed(2);
  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

     },

     async spe_dis() {
        const total = this.subtotal - this.quotation.special_discount;
        this.final_total = total.toFixed(2);
     },

    async UpdateQuotation() {
       
      console.log(this.squatation);
      console.log(this.quotation);

    console.log("amila");
       try {
         const { data} = await  axios.post('/squatation/update',{idquotation:this.idquotation,userid:this.userid,squatation:this.squatation,quotation:this.quotation,sales:this.sales,quatation_details:this.quatation_details},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
          this.$router.push('/quotation/view?id='+this.idquotation);
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    